import * as api from '../api'
import useApiMutation from './useApiMutation'

export default function useOnDemandCourseHeartbeat() {
  return useApiMutation({
    mutationFn: async ({ courseUuid }: { courseUuid: string }) => {
      await api.get(`on-demand-course/${courseUuid}/heartbeat`)
    },
  })
}
